import { FC } from "react";
import { AxiosError } from "axios";
import { ReportApi } from "@/api/ReportApi";
import Logger from "../../../utils/Logger";
import ExportResultQueryParams from "@/interfaces/ExportResultQueryParams";

interface ExportResultsProps {
  setErrorStatus: (error: AxiosError | { message?: string } | string) => void;
  setErrorType: (type: string) => void;
  setLoading: (loading: boolean) => void;
  searchParams: ExportResultQueryParams;
}

const ExportResults: FC<ExportResultsProps> = ({
  setErrorType,
  setErrorStatus,
  setLoading,
  searchParams,
}) => {
  const handleExportResults = async () => {
    try {
      setLoading(true);
      setErrorStatus("");
      Logger.info("Starting CSV export process", ["ExportResults"]);
      
      const { data, filename } = await ReportApi.fetchExportResultsCSV(searchParams);

      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Logger.info("Results export completed successfully", ["ExportResults"]);
    } catch (error) {
      console.error("Error exporting search results:", error);
      setErrorType("exportCSV");
      Logger.error("Error exporting search results", error, ["ExportResults"]);
      setErrorStatus(error as AxiosError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center" >
      <button
        type="button"
        id="export-results-button"
        aria-label="Export Results Data"
        className="flex m-4 inline-block items-center text-blue px-4"
        onClick={handleExportResults}
        title="Export facility details for current search results"
      >
        <span className="icon-cloud_download text-blue text-3xl pr-2" />
        <span
          className="flex pl-[8px] text-[16px] text-center "
          role="menuitem"
          tabIndex={0}
        >
          Export Results
        </span>
      </button>
    </div>
  );
};

export default ExportResults;